import { HttpError } from 'lib/https';

export const CONVERSATION_ACCESS_ERROR_KEYS = {
  NOT_FOUND: 'CONVERSATION_NOT_FOUND',
  ACCESS_DENIED: 'CONVERSATION_ACCESS_DENIED',
  UNABLE_TO_LOAD: 'UNABLE_TO_LOAD_CONVERSATION',
} as const;

const API_DETAIL_TO_TRANSLATION_KEY: Record<string, string> = {
  'Conversation not found.': CONVERSATION_ACCESS_ERROR_KEYS.NOT_FOUND,
  'You do not have permission to view this conversation.':
    CONVERSATION_ACCESS_ERROR_KEYS.ACCESS_DENIED,
};

export function getConversationAccessErrorMessage(error: unknown): string {
  if (error instanceof HttpError) {
    const detail = error.error?.detail;
    if (typeof detail === 'string' && detail.trim()) {
      const normalizedDetail = detail.trim();
      return API_DETAIL_TO_TRANSLATION_KEY[normalizedDetail] ?? normalizedDetail;
    }
    if (error.status === 403) {
      return CONVERSATION_ACCESS_ERROR_KEYS.ACCESS_DENIED;
    }
    if (error.status === 404) {
      return CONVERSATION_ACCESS_ERROR_KEYS.NOT_FOUND;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    const normalizedMessage = error.message.trim();
    return API_DETAIL_TO_TRANSLATION_KEY[normalizedMessage] ?? normalizedMessage;
  }

  return CONVERSATION_ACCESS_ERROR_KEYS.UNABLE_TO_LOAD;
}

const ACCESS_ERROR_VALUES = new Set<string>(Object.values(CONVERSATION_ACCESS_ERROR_KEYS));

/** True when the error means the conversation cannot be opened (not an in-chat stream error). */
export function isConversationAccessError(error: string): boolean {
  if (ACCESS_ERROR_VALUES.has(error)) return true;
  return Object.prototype.hasOwnProperty.call(API_DETAIL_TO_TRANSLATION_KEY, error);
}

/**
 * Full-page "Conversation unavailable" — only when there is no local history yet and the
 * failure is a real access/load problem (not stream timeout or other in-chat errors).
 */
export function shouldShowConversationUnavailable(
  error: string | null | undefined,
  hasLocalMessages: boolean,
): boolean {
  if (!error || hasLocalMessages) return false;
  return isConversationAccessError(error);
}
